import { useLingui } from "@lingui/react/macro";
import { organizationApi } from "@/lib/api/services/organization.api";
import type { Organization } from "@/types/organization";
import { EntitySelect } from "./EntitySelect";

export interface OrganizationSelectProps {
  value: number | null | undefined;
  onChange: (value: number, organization: Organization) => void;
  onClear?: () => void;
  isActive?: boolean;
  /** Pass true to use the super-admin scope (all organizations). */
  adminScope?: boolean;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function OrganizationSelect({
  value,
  onChange,
  onClear,
  isActive,
  adminScope,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: OrganizationSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Organization>
      queryKeyBase={["entity-select", "organizations", isActive ?? null, adminScope ?? null]}
      fetchPage={({ page, limit, search }) =>
        organizationApi.paginate(
          { page, limit, search: search || undefined, isActive },
          { adminScope },
        )
      }
      getOptionValue={(o) => String(o.id)}
      getOptionLabel={(o) => o.name}
      fetchItem={(id) => organizationApi.getById(Number(id))}
      value={value == null ? "" : String(value)}
      onChange={(val, organization) => onChange(Number(val), organization)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select an organization...`}
      searchPlaceholder={t`Search organizations…`}
      emptyMessage={t`No organizations found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
